// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-link[data-v-da35e35c]{color:#999;cursor:pointer;font-size:12px}.arrow-icon[data-v-da35e35c]{width:10px;height:10px;transform:rotate(360deg)}.arrow-icon.toggle[data-v-da35e35c]{transform:rotate(180deg)}\n", ""]);
// Exports
module.exports = exports;
